/**
 * Guest portal API shapes (T-024 · W2-CONTRACTS §6 · D-025)
 * guest link สำหรับผู้ติดต่อที่ไม่มี SSO: /g/<token> → ขอ OTP → verify → guest session
 */
import { z } from "zod";

export const GuestLinkCreate = z.object({
  email: z.email(),
  purpose: z.enum(["view", "reply"]).optional(),
  expires_at: z.iso.datetime().optional(),
});
export type GuestLinkCreate = z.infer<typeof GuestLinkCreate>;

/** url (ลิงก์พร้อม token ดิบ) แสดงครั้งเดียวเฉพาะตอนสร้าง — การดูรายการไม่มี url */
export const GuestLink = z.object({
  id: z.uuid(),
  url: z.string().optional(),
  email: z.string(),
  purpose: z.enum(["view", "reply", "approve", "csat"]),
  expires_at: z.iso.datetime(),
  revoked_at: z.iso.datetime().nullable(),
});
export type GuestLink = z.infer<typeof GuestLink>;

/** ต้อง confirm ก่อนขอ OTP — กัน link-preview bot กิน OTP (03 §1.3) */
/** [Lead #80] GET /api/v1/guest/:token/info — ข้อมูลที่หน้า /g/:token แสดงก่อนขอ OTP (404 เมื่อลิงก์ไม่มี/หมดอายุ/ถูกเพิกถอน) */
export const GuestLinkInfo = z.object({
  /** public id ของการ์ดที่ลิงก์นี้เปิดได้ */
  ticket_id: z.string(),
  /** อีเมลปลายทางแบบปิดบัง เช่น "s••••ai@example.com" (ไม่ส่งอีเมลเต็มก่อนยืนยันตัว) */
  email_masked: z.string(),
  expires_at: z.iso.datetime(),
});
export type GuestLinkInfo = z.infer<typeof GuestLinkInfo>;

export const GuestOtpRequest = z.object({ confirm: z.literal(true) });

/** [Lead/T-059] POST /api/v1/guest/track — ขอลิงก์เปิดเคสทางอีเมล (202 เสมอ ไม่บอกว่ามีเคส/อีเมลตรงหรือไม่) */
export const GuestTrackRequest = z.object({ ticket_id: z.string().trim().min(3).max(24), email: z.email() });
export type GuestTrackRequest = z.infer<typeof GuestTrackRequest>;
export type GuestOtpRequest = z.infer<typeof GuestOtpRequest>;

export const GuestVerify = z.object({ code: z.string().regex(/^\d{6}$/) });
export type GuestVerify = z.infer<typeof GuestVerify>;

export const GuestSession = z.object({
  /** ticket public id ที่ session จำกัดขอบเขต */
  ticket_id: z.string(),
  email: z.string(),
});
export type GuestSession = z.infer<typeof GuestSession>;
